export class IRegistration {
    org?: string;
    firstName?: string;
    lastName?: string;
    email: string;
    country: string;
    acceptPolicy: boolean;
    subscribeMarketing?: boolean;
}
